<template>
  <div>
    <page-header :title="$t('scope.operation_records_list')" :tabs="tabs" :current-tab.sync="currentTab" />
    <page-body>
      <keep-alive>
        <list v-if="currentTab === 'report'" :id="listId" />
        <chart v-else :dayType="dayType" :changeDayType="changeDayType" />
      </keep-alive>
    </page-body>
  </div>
</template>

<script>
import List from './components/List'
import Chart from './components/Chart'

export default {
  name: 'OperationRecordsIndex',
  components: {
    List,
    Chart,
  },
  data () {
    return {
      listId: 'OperationRecordsList',
      dayType: '30',
      tabs: [
        {
          key: 'report',
          label: '表',
        },
        {
          key: 'chart',
          label: '图',
        },
      ],
      currentTab: 'report',
    }
  },
  methods: {
    changeDayType (val) {
      this.dayType = val
    },
  },
}
</script>
